
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HeadlineSettings"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"settings"},"name":{"kind":"Name","value":"attributes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"contentMarketing","block":false},{"kind":"StringValue","value":"trending","block":false},{"kind":"StringValue","value":"icon.audio","block":false},{"kind":"StringValue","value":"icon.image","block":false},{"kind":"StringValue","value":"icon.live","block":false},{"kind":"StringValue","value":"icon.reklama","block":false},{"kind":"StringValue","value":"icon.sponsored_content","block":false},{"kind":"StringValue","value":"icon.video","block":false},{"kind":"StringValue","value":"frontPageImportant","block":false},{"kind":"StringValue","value":"frontPageSponsoredContent","block":false},{"kind":"StringValue","value":"frontPageBreakingNews","block":false},{"kind":"StringValue","value":"frontPageResearch","block":false},{"kind":"StringValue","value":"frontPageRenewed","block":false},{"kind":"StringValue","value":"frontPageImage","block":false},{"kind":"StringValue","value":"frontPageVideo","block":false},{"kind":"StringValue","value":"frontPageAudio","block":false},{"kind":"StringValue","value":"frontPageGraph","block":false},{"kind":"StringValue","value":"frontPageLiveVideo","block":false},{"kind":"StringValue","value":"frontPagePoliticalAd","block":false},{"kind":"StringValue","value":"frontPageInterview","block":false},{"kind":"StringValue","value":"frontPageInvestigativeJournalism","block":false},{"kind":"StringValue","value":"frontPagePremiere","block":false},{"kind":"StringValue","value":"frontPageTest","block":false},{"kind":"StringValue","value":"frontPageInvest","block":false},{"kind":"StringValue","value":"frontPageSustainabilityCourse","block":false},{"kind":"StringValue","value":"frontPageMostPopularJobOffers","block":false},{"kind":"StringValue","value":"frontPageLookingForTalents","block":false},{"kind":"StringValue","value":"frontPageInterviewWithCLevelManagers","block":false},{"kind":"StringValue","value":"frontPageRelevantInTheOffice","block":false},{"kind":"StringValue","value":"frontPageItsInteresting","block":false},{"kind":"StringValue","value":"frontPageHHRPerspective","block":false},{"kind":"StringValue","value":"articleDelfiShort","block":false},{"kind":"StringValue","value":"articleLiveBlog","block":false},{"kind":"StringValue","value":"specialProject","block":false}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"true","block":false}]}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":1152}};
    doc.loc.source = {"body":"fragment HeadlineSettings on Article {\n  settings: attributes(\n    input: {\n      key: [\n        \"contentMarketing\"\n        \"trending\"\n        \"icon.audio\"\n        \"icon.image\"\n        \"icon.live\"\n        \"icon.reklama\"\n        \"icon.sponsored_content\"\n        \"icon.video\"\n        \"frontPageImportant\"\n        \"frontPageSponsoredContent\"\n        \"frontPageBreakingNews\"\n        \"frontPageResearch\"\n        \"frontPageRenewed\"\n        \"frontPageImage\"\n        \"frontPageVideo\"\n        \"frontPageAudio\"\n        \"frontPageGraph\"\n        \"frontPageLiveVideo\"\n        \"frontPagePoliticalAd\"\n        \"frontPageInterview\"\n        \"frontPageInvestigativeJournalism\"\n        \"frontPagePremiere\"\n        \"frontPageTest\"\n        \"frontPageInvest\"\n        \"frontPageSustainabilityCourse\"\n        \"frontPageMostPopularJobOffers\"\n        \"frontPageLookingForTalents\"\n        \"frontPageInterviewWithCLevelManagers\"\n        \"frontPageRelevantInTheOffice\"\n        \"frontPageItsInteresting\"\n        \"frontPageHHRPerspective\"\n        \"articleDelfiShort\"\n        \"articleLiveBlog\"\n        \"specialProject\"\n      ]\n      value: [\"true\"]\n    }\n  ) {\n    key\n    value\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["HeadlineSettings"] = oneQuery(doc, "HeadlineSettings");
        
